import { Grid } from "@mui/material"

import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined';

import AICreditsCard from "./utils/aiCreditsCard";
import UsageOverview from "./utils/usageOverview";
import ConnectedChannels from "./utils/connectedChannels";

import { useBillingStore } from "../../../store/billingStore";
import { useShallow } from "zustand/react/shallow";
import { billingSubscriptionFeatures, billingSubscriptionPlan } from "../../../models/axiosModel";
import { COMPLIMENTARY_AI_CREDITS_FEATURE, PLANS } from "../constant.billing";
import { channelDeploymentLimits, isCurrentPlanPublic, usageLimits } from "../utils.billing";
import PurchaseCredits from "./utils/purchaseCredits";

const UsageSection = () => {

    const { billingSubscriptionDetails } = useBillingStore(useShallow((state) => ({
      billingSubscriptionDetails: state.billingSubscriptionDetails,
    })));

    const currentPlan = billingSubscriptionDetails?.current_plan;

    const usageLimitsData = usageLimits(billingSubscriptionDetails);
    const channelDeploymentLimitsData = channelDeploymentLimits(billingSubscriptionDetails);

    const complimentaryAICredits = usageLimitsData?.features?.filter((feature: billingSubscriptionFeatures) => (
      feature.billing_feature_name === COMPLIMENTARY_AI_CREDITS_FEATURE
    ));
    
    const complimentaryCredits = complimentaryAICredits?.find((feature: billingSubscriptionFeatures) => !feature.flag_add_on_limit);
    const purchasedCredits = complimentaryAICredits?.find((feature: billingSubscriptionFeatures) => feature.flag_add_on_limit);

    const shouldShowPurchaseCredits = currentPlan 
      && isCurrentPlanPublic(currentPlan)
      && currentPlan?.billing_plan_name?.toLowerCase() !== PLANS.FREE;
    
    return (
      <Grid container spacing={3}>
        
        <Grid item xs={12}>
            <Grid container spacing={3}>
              
              <Grid item xs={12} lg={6}>
                <AICreditsCard
                    variant="complimentary"
                    icon={<AutoAwesomeOutlinedIcon />}
                    title="Complimentary Credits"
                    description="Included with your plan"
                    chipText="Expires monthly"
                    expiresDescription="Unused complimentary credits do not roll over."
                    cardData={complimentaryCredits as billingSubscriptionFeatures}
                />
              </Grid>

              {purchasedCredits && (
                <Grid item xs={12} lg={6}>
                  <AICreditsCard
                      variant="purchased"
                      icon={<BoltOutlinedIcon />}
                      title="Purchased Credits"
                      description="From your add-on packs"
                      chipText="Rolls over"
                      expiresDescription="Unused AI credits are carried forward to the next billing cycle."
                      cardData={purchasedCredits as billingSubscriptionFeatures}
                  />
                </Grid>
              )}

            </Grid>
        </Grid>

        {shouldShowPurchaseCredits && (
          <Grid item xs={12}>
            <PurchaseCredits />
          </Grid>
        )}

        <Grid item xs={12}>
            <UsageOverview usageLimitsData={usageLimitsData} />
        </Grid>

        <Grid item xs={12}>
          <ConnectedChannels connectedChannelsData={channelDeploymentLimitsData} />
        </Grid>

      </Grid>
    )
  }
  
export default UsageSection;
